import { useState, useEffect, useMemo } from "react";

export const useLiveEnvironment = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [liveTemp, setLiveTemp] = useState(null);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);
    return () => clearInterval(timer);
  }, []);

  // useEffect(() => {
  //   const fetchWorldWeather = async (lat, lon) => {
  //     try {
  //       const response = await fetch(
  //         `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&current=temperature_2m`,
  //       );
  //       const data = await response.json();
  //       if (data?.current?.temperature_2m !== undefined) {
  //         setLiveTemp(Math.round(data.current.temperature_2m));
  //       }
  //     } catch (error) {
  //       console.error("Weather fetch failed", error);
  //     }
  //   };

  //   const determineLocationAndFetch = () => {
  //     if (navigator.geolocation) {
  //       navigator.geolocation.getCurrentPosition(
  //         position => {
  //           fetchWorldWeather(position.coords.latitude, position.coords.longitude);
  //         },
  //         async () => {
  //           // ✅ Geolocation fail hone par IP se location lo
  //           try {
  //             const res = await fetch("https://ipapi.co/json/");
  //             const loc = await res.json();
  //             fetchWorldWeather(loc.latitude, loc.longitude);
  //           } catch {
  //             // Last resort — Ahmedabad fallback
  //             fetchWorldWeather(23.0225, 72.5714);
  //           }
  //         },
  //         { enableHighAccuracy: true, timeout: 10000 },
  //       );
  //     } else {
  //       fetchWorldWeather(23.0225, 72.5714);
  //     }
  //   };
  //   determineLocationAndFetch();

  //   const weatherLoop = setInterval(determineLocationAndFetch, 900000);
  //   return () => clearInterval(weatherLoop);
  // }, []);

  const timePhase = useMemo(() => {
    const hours = currentTime.getHours();
    if (hours >= 5 && hours < 8) return "sunrise";
    if (hours >= 8 && hours < 12) return "morning";
    if (hours >= 12 && hours < 17) return "noon";
    if (hours >= 17 && hours < 20) return "evening";
    return "night";
  }, [currentTime]);

  return { currentTime, liveTemp, timePhase };
};
